import * as yup from "yup";
import { isValidPhoneNumber } from "react-phone-number-input";

const today = new Date();
today.setFullYear(today.getFullYear()-1);
export const signUpSchema = yup.object().shape({
    name: yup.string().required('Name is required'),
    email: yup.string().email().required('Email is required'),
    username: yup.string().required('Username is required'),
    // Validated as E.164 rather than digits-only: the API canonicalizes with
    // libphonenumber and rejects anything a carrier could not route.
    phone: yup
        .string()
        .required('Phone number is required')
        .test('e164', 'Enter a valid phone number with its country code', (value) =>
            !!value && isValidPhoneNumber(value)
        ),
    password: yup.string().required('Password is required'),
    termsAndConditions: yup.boolean().oneOf([true], 'Please accept Terms and Conditions.'),
    grps: yup.boolean().oneOf([true], 'Please accept gdpr policy.')
}).required();